import {ClosePopup} from 'brand/header/ClosePopup'

export const ActionPanel = ({children, title, show, onClose}) => (
  <div className={`modal ${show ? 'show' : 'hide'} float-cover`}>
    <div className="off-modal" onClick={onClose}/>
    <div className="action-panel">
      <ClosePopup onClose={onClose}>{title}</ClosePopup>
      {children}
    </div>
  </div>
)
